"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = require("./form-definition");
var form_constants_1 = require("./form-constants");
/**
 * Returns an array with the labels of selected multiple choice values,
 * if one of the options selected is the other option the value of the other text element is returned instead of the label.
 * @param groupElement a group element with data format of MULTIPLE_CHOICE_OTHER
 * @param groupValue the value of the group
 * @param state
 */
function getMCOtherLabels(groupElement, groupValue, state) {
    if (!groupElement || !groupValue)
        return [];
    if (groupElement.dataFormat && groupElement.dataFormat.type === form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER) {
        var dataFormat_1 = groupElement.dataFormat;
        var mcElement = form_definition_1.getElementById(state, dataFormat_1.mcElementId);
        var mcValue_1 = groupValue.mcValue ? groupValue.mcValue.toArray() : [];
        var selectedOptions = mcElement ? mcElement.options.filter(function (opt) { return mcValue_1.includes(opt.value); }) : [];
        var otherValue_1 = groupValue.otherValue ? groupValue.otherValue : '';
        return selectedOptions.map(function (option) { return option.value === dataFormat_1.otherOptionValue ? otherValue_1 : option.label; });
    }
    else {
        return [];
    }
}
exports.getMCOtherLabels = getMCOtherLabels;
//# sourceMappingURL=group-data-format-helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/group-data-format-helpers.js
// module id = 1149
// module chunks = 0